import {Component, OnInit} from '@angular/core';
import {PopupDialogBase} from '../popup-dialog-base';

@Component({
    selector: 'app-attachment-list',
    templateUrl: './attachment-list.component.html',
    styleUrls: ['./attachment-list.component.css'],
    standalone: false
})
export class AttachmentListComponent extends PopupDialogBase implements OnInit {
  attachmentIds: string[] = []

  selectedIndex = 0;
  selectedAttachmentId: string;

  constructor() {
    super();
  }

  ngOnInit() {
    this.loadAttachment();
  }

  private loadAttachment() {
    this.selectedAttachmentId = this.attachmentIds[this.selectedIndex];
  }

  prevImage() {
    if (this.selectedIndex != 0) {
      this.selectedIndex--;
      this.loadAttachment();
    }
  }

  nextImage() {
    if (this.selectedIndex != this.attachmentIds.length - 1) {
      this.selectedIndex++;
      this.loadAttachment();
    }
  }
}
